import React from 'react';

const Footer = () => (
  <div className='bg-slate-300 mt-10'>
    <div className='gap-10 items-center flex-wrap px-10 pt-5 font-serif text-lg'>
      ShapeUp.0.01
    </div>
    <div className='text-md mt-10 mr-8 text-right'>
      Made by RD.2024
    </div>
  </div>
);

export default Footer;